import { Specification } from '@a3l/core';
import {OrganizationUserStatusEnum} from "@rex/organization/enums/organization-user-status.enum";

export class ClientCompanyIsBlockedSpecification extends Specification<any> {
  isSatisfiedBy(user: any): boolean {
    return user.client_company_user_suspended_to !== null && user.client_company_user_suspended_to !== undefined;
  }
}
